var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCvIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #101437;\n      }\n\n      .cls-3 {\n        fill: #ffc400;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "infos_icons",
    "data-name": "infos icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cvIcon"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_520",
    "data-name": "Groupe 520"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_953",
    "data-name": "Trac\\xE9 953",
    className: "cls-2",
    d: "M26.1,17.75l39.28-4.83a5.62,5.62,0,0,1,6.29,4.86h0L78.83,76a5.63,5.63,0,0,1-4.93,6.23L34.62,87.08a5.62,5.62,0,0,1-6.29-4.86L21.17,24A5.63,5.63,0,0,1,26.1,17.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1652",
    "data-name": "Rectangle 1652",
    className: "cls-3",
    d: "M34.5,49.81,65.37,46a2.6,2.6,0,0,1,2.89,2.26h0A2.59,2.59,0,0,1,66,51.16L35.14,55a2.58,2.58,0,0,1-2.89-2.25h0A2.58,2.58,0,0,1,34.5,49.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_952",
    "data-name": "Trac\\xE9 952",
    className: "cls-3",
    d: "M52.73,25.23l7.72-.95a2.59,2.59,0,1,1,.63,5.14l-7.71.95a2.59,2.59,0,1,1-.64-5.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_951",
    "data-name": "Trac\\xE9 951",
    className: "cls-3",
    d: "M54,36.09l7.71-1a2.59,2.59,0,0,1,.63,5.15l-7.71.94A2.59,2.59,0,1,1,54,36.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_950",
    "data-name": "Trac\\xE9 950",
    className: "cls-3",
    d: "M36.29,60.33l15.43-1.89a2.59,2.59,0,1,1,.63,5.14L36.92,65.47a2.59,2.59,0,1,1-.63-5.14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1654",
    "data-name": "Rectangle 1654",
    className: "cls-3",
    x: 32.83,
    y: 25.95,
    width: 12.96,
    height: 15.55,
    rx: 5.18,
    transform: "translate(-3.82 5.04) rotate(-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1653",
    "data-name": "Rectangle 1653",
    className: "cls-3",
    d: "M37.1,70.54,68,66.75A2.6,2.6,0,0,1,70.85,69h0a2.6,2.6,0,0,1-2.26,2.89L37.73,75.69a2.6,2.6,0,0,1-2.89-2.26h0A2.6,2.6,0,0,1,37.1,70.54Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvIcon);
export default __webpack_public_path__ + "static/media/cvIcon.0f2d2266619c4896a1e2759634f31dc5.svg";
export { ForwardRef as ReactComponent };